type LogoProps = {
  size?: number;
  withWordmark?: boolean;
};

export function Logo({ size = 28, withWordmark = false }: LogoProps) {
  return (
    <span className="logo" data-with-wordmark={withWordmark}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Alibi"
        role="img"
      >
        <rect width="64" height="64" rx="14" fill="#0f0f10" />
        <path d="M18 46 L32 18 L46 46 H38 L32 33 L26 46 Z" fill="#f97316" />
      </svg>
      {withWordmark && <span className="wordmark">Alibi</span>}
    </span>
  );
}
